import React from 'react';
import { useAtomValue } from 'jotai';
import type { SearchSuggestion } from '@rocco/ui/search/view-models/search-suggestion';
import { CarouselSection } from '@rocco/ui/layout/components/CarouselSection';
import { CardSearchCategory } from '@rocco/ui/search/components/CardSearchCategory';
import { searchPageDataAtom } from '../states/search-page-data-atom';

interface SearchSuggestedCategoriesProps {
    onSuggestedCategoryClick: (category: SearchSuggestion) => void;
}

/**
 * Renders a carousel of suggested search categories based on the current search context.
 */
export const SearchSuggestedCategories: React.FC<
    SearchSuggestedCategoriesProps
> = ({ onSuggestedCategoryClick }) => {
    const pageDataFromAtom = useAtomValue(searchPageDataAtom);
    const suggestedCategories = pageDataFromAtom?.suggestedCategories ?? [];

    if (suggestedCategories.length === 0) {
        return null;
    }

    return (
        <CarouselSection size={'suggestedCategories'} showArrows={false}>
            {suggestedCategories.map((category: SearchSuggestion) => (
                <CardSearchCategory
                    key={category.link}
                    category={{
                        title: category.title,
                        link: category.link,
                        image: category.image ?? '',
                        type: category.type,
                    }}
                    onClick={() => onSuggestedCategoryClick(category)}
                />
            ))}
        </CarouselSection>
    );
};
